module.exports = __webpack_public_path__ + "static/media/studio1-1.5acaabb5.png";